import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  data: () => ({
    is_dragging: false,
  }),

  methods: {
    handleDragStart(e){
      this.is_dragging = true
    },
    handleDragStop(e){
      this.is_dragging = false
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
  }
};